export default {
  styleOverrides: {
    root: {
      textTransform: 'uppercase'
    },
  },
};
